import { useSelector } from 'react-redux'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import Pagination from '../../../../../components/ui/Pagination'

// Generic list body shared by all three freebet tabs. Mirrors MyTransactions'
// four render states (loading / error / empty / list) and reuses the exact
// transaction + my-transactions classes so the look matches. The tab supplies
// its own header columns, rows, per-row card renderer, and pagination total.
const Shell = ({ children }) => (
  <div className="standard-normal-my-transactions-outer-container">
    <div className="standard-normal-my-transactions-inner-container">{children}</div>
  </div>
)

const FreebetsList = ({
  headerElements,
  rows,
  renderCard,
  isPending,
  isError,
  emptyMessage = 'Nothing here yet',
  total,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  const { displayCurrencyCode } = useSelector((state) => state.wallet)

  if (isPending) {
    return (
      <Shell>
        <div className="standard-normal-my-transactions-loading-container">
          <SpinningLoader />
        </div>
      </Shell>
    )
  }

  if (isError) {
    return (
      <Shell>
        <div className="standard-normal-my-transactions-error-container">
          Ooops! Something Went Wrong!
        </div>
      </Shell>
    )
  }

  if (!rows.length) {
    return (
      <Shell>
        <div className="standard-normal-my-transactions-empty-message-container">
          {emptyMessage}
        </div>
      </Shell>
    )
  }

  return (
    <Shell>
      <div className="standard-normal-my-transactions-list-container">
        <div className="standard-normal-transaction-outer-container">
          <div className="standard-normal-transaction-header-container">
            {headerElements.map((element, index) => (
              <div key={index} className="standard-normal-transaction-header-element-container">
                <div className="standard-normal-transaction-header-element">{element.label}</div>
                {element.currency && (
                  <div className="standard-normal-transaction-header-element-currency">
                    [ {displayCurrencyCode} ]
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="standard-normal-transaction-inner-container no-scrollbar">
            {rows.map((row, index) => renderCard(row, index))}
          </div>
        </div>
      </div>
      <div className="standard-normal-my-transactions-pagination-container">
        <Pagination
          totalItems={total}
          itemsPerPage={pageSize}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      </div>
    </Shell>
  )
}

export default FreebetsList
